<template>
    <p class="mb-0">
        <table class="table table-striped table-sm" v-if="calculationData">
            <thead>
                <tr>
                    <th style="width:10%">Datum</th>
                    <th>Projekt</th>
                    <th>Kategori</th>
                    <th style="width:10%" class="text-center">Kvitto</th>
                    <th style="width:10%" class="text-right">Kostnad</th>                
                </tr>
            </thead>   
            <tbody>
                <tr v-for="entry in calculationData.Expenses" :key="entry.id">
                    <td style="width:15%">{{entry.Spent | moment("YYYY-MM-DD")}}</td>
                    <td>{{entry.Project}}</td>
                    <td>{{entry.Category}}</td>
                    <td style="width:10%" class="text-center"><a href="#" v-on:click="downloadReceipt(entry)" class="cui-paperclip icons"></a></td>
                    <td style="width:10%" class="text-right">{{entry.Cost | currency}}</td>                 
                </tr>       
            </tbody> 
            <tfoot>
                <tr>
                    <th colspan="4">Summa</th>                
                    <td class="text-right"><strong>{{calculationData.Expenses.reduce((s, f) => s+f.Cost, 0) | currency}}</strong></td>
                </tr>
            </tfoot>
        </table>
    </p>
</template>

<script>
import { expensesService } from "../../../../shared/services";
export default {
    components: {
        expensesService

    },
    props: {
        calculationData: null
    },
    methods:{
        downloadReceipt(entry) {
            var expense  = {
                id: entry.Id,
                receiptFileName: entry.ReceiptFileName
            }
            if(!expense.receiptFileName) {
                expense.receiptFileName = entry.Receipt.substring(entry.Receipt.lastIndexOf('/')+1);
            }
            expensesService.downloadReceipt(expense);
        }
    }

}
</script>

<style>

</style>
